import { useApi, apiResolver } from "@/api/useApi";
import { Enrichment } from "./Enrichment.model";

type CreateEnrichmentRequest = Omit<
  Enrichment,
  "id" | "createdAt" | "updatedAt" | "createdBy" | "copilotBlocks"
>;

type UpdateEnrichmentRequest = Omit<
  Enrichment,
  "createdAt" | "updatedAt" | "createdBy" | "copilotBlocks"
>;

export function useEnrichmentApi() {
  const { api } = useApi();

  return {
    getAll: async () =>
      apiResolver<Enrichment[]>(api.get("/platform/enrichments")),
    getById: async (id: string) =>
      apiResolver<Enrichment>(api.get(`/platform/enrichments/${id}`)),
    create: async (request: CreateEnrichmentRequest) =>
      apiResolver<Enrichment>(api.post("/platform/enrichments", request)),
    update: async (request: UpdateEnrichmentRequest) =>
      apiResolver<Enrichment>(
        api.put(`/platform/enrichments/${request.id}`, request)
      ),
    delete: async (id: string) =>
      apiResolver<void>(api.delete(`/platform/enrichments/${id}`)),
    toggle: async (id: string) =>
      apiResolver<Enrichment>(api.put(`/platform/enrichments/${id}/toggle`)),
  };
}
